module.exports = __webpack_public_path__ + "static/media/circle_blur_purple@2x.07a4a980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/greeting/circle_blur_purple@2x.png
// module id = 403
// module chunks = 0